import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=212565c5&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212565c5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('212565c5')) {
      api.createRecord('212565c5', component.options)
    } else {
      api.reload('212565c5', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=212565c5&scoped=true", function () {
      api.rerender('212565c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/student/medical-plan/Main.vue"
export default component.exports